import {
    Icon,
    IconButton
} from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { StandardTable } from '../../../_components/table/standard.table';
import { PaperTableHeader } from '../../../_components/table/header.table';
import { TABLE_FILTER } from '../../../_const/tableFilter.const';
import { handleErrorResponse } from '../../../_helpers/handleResponse.helper';
import { SearchTableHeader } from '../../../_components/table/search.table';
import { centreService } from '../../../_services/centre.service';
import { StandardViewPanel } from '../../../_components/panel/standardView.panel';
import { CentreDetailsManageDrawer } from './centre-detailsManageDrawer';



export const CentreDetailsPanel = () => {
    const { centreId } = useParams<{ centreId: string }>();
    const [data, setData] = useState<any>({ items: [], count: 10 });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const fetchData = async () => {
        if (!centreId) return;
        setIsLoading(true);
        return await centreService.getLatest(centreId)
            .then(
                json => {
                    console.log(json)
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [centreId]);

    const rows = [
        { label: 'Name', value: data.name },
        { label: 'Manager', value: data.centreManagerName },
        { label: 'Address', value: data.address },
        { label: 'Telephone', value: data.telephone },
        { label: 'Mobile', value: data.mobile },
        { label: 'Email', value: data.email },
        { label: 'Fax', value: data.fax },
        { label: 'Fire Alarm Code', value: data.fireAlarmCode },
        { label: 'House Alarm Code', value: data.houseAlarmCode },
        { label: 'IP', value: data.ip },
        { label: 'Share Point URL', value: data.sharePointUrl },
        { label: 'Email Password', value: data.emailPassword },


    ]

    return (
        <>
            <StandardViewPanel
                title="Centre Details" buttons={[
                    { icon: "edit", onClick: () => { navigate("ManageDetails/") }}
                ]}
                loading={isLoading}
                items={rows} />

            <Routes>
                <Route path="ManageDetails/" element={<CentreDetailsManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate(""); fetchData(); }} />} />
            </Routes>
        </>
    );
};